import React from 'react'

import Base from '../_Base'

const CsTriangle = (props) => (
  <Base width="14" height="7" viewBox="0 0 14 7" {...props}>
    <path d="M7 0l7 7H0z" fillRule="evenodd" />
  </Base>
)

export default CsTriangle
